import React from "react";
import styled, { injectGlobal } from "styled-components";
import { withI18n, Trans } from "react-i18next";
import { Typography } from "components/Common";
import FeatureCheckIcon from "../../images/feature-check.svg";
import { useLoadFont } from "helpers/hooks";

interface IProps {
  t?: any;
}

const ActorSellingFeatures2025OptionA: React.FC<IProps> = ({ t }) => {
  useLoadFont("https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap");

  return (
    <Container>
      <Title><Trans i18nKey="standingOutTakesMoreThanHeadshot">Today,<br/> <span><b>Standing Out</b></span><br/> Takes more than<br/> a <span>Headshot!</span></Trans></Title>
      <Lead><Trans i18nKey="experienceWhatProGives">Experience what <b>PRO</b> gives to you for <b>FREE</b></Trans></Lead>
      <FeatureUl>
        <FeatureLi>
          <FeatureIcon/>
          <Typography>{t('Custom Website')}</Typography>
        </FeatureLi>
        <FeatureLi>
          <FeatureIcon/>
          <Typography>{t('Jobs & Auditions')}</Typography>
        </FeatureLi>
        <FeatureLi>
          <FeatureIcon/>
          <Typography>{t('All your Demo Reels')}</Typography>
        </FeatureLi>
        <FeatureLi>
          <FeatureIcon/>
          <Typography>{t('Marketing Tools')}</Typography>
        </FeatureLi>
      </FeatureUl>
    </Container>
  );
};

export default withI18n()(ActorSellingFeatures2025OptionA);

injectGlobal`
  body {
    background-color: #EEF0F5 !important;
  }
`;

const Container = styled.div`
  max-width: 710px;
  background-color: #FFFFFF;
  margin: 0 auto;

  margin-top: 20px;

  display: flex;
  flex-direction: column;
  
  padding: 30px 30px 24px;
  border-radius: 10px;

  @media(min-width: 768px) {
    margin-top: 40px;
    border-radius: 10px;
    padding: 64px 60px 30px;
    min-height: 508px;
  }
  @media(min-width: 1024px) {
    margin-right: 0;
  }

  @media all and (max-width: 768px) {
    float:none !important;
  }

  @media all and (max-width: 520px) {
    padding: 8px;
    max-width: 680px;
    min-width: 40%;
    float: none !important;
    margin-bottom: 0;
    width: 100%;
  }
`;

const Title = styled(Typography)`
  font-weight: 700;
  font-size: 28px;
  line-height: 38px;
  margin-bottom: 14px;

  @media(min-width: 480px) {
    font-size: 52px;
    line-height: 62px;
    margin-bottom: 24px;
  }
  @media(min-width: 1024px) {
    font-size: 64px;
    line-height: 76px;
  }

  & > b{
    font-weight: 800;
  }

  & > span{
    color: ${p => p.theme.lightBlue};
  }
`;

const Lead = styled(Typography)`
  font-size: 20px;
  line-height: 28px;
  margin-bottom: 24px;
`;

const FeatureUl = styled.ul`
  background-color: #FAFDFF;
  list-style: none;
  padding-left: 0;
  display: flex;
  flex-flow: wrap column;
  padding: 8px;

  @media(min-width: 480px) {
    padding: 0;
    height: 100px;
  }
`;

const FeatureLi = styled.li`
  display: flex;
  flex-flow: nowrap row;
  align-items: center;
  padding: 8px;

  @media(min-width: 480px) {
    padding: 0 8px;
    width: 49%;
    flex-basis: 50%;
  }
`;

const FeatureIcon = styled.img.attrs({
  src: FeatureCheckIcon,
})`
  margin-right: 12px;
`;
